import { tns } from "tiny-slider/src/tiny-slider";

document.addEventListener("DOMContentLoaded", function (e) {
	var slider = tns({
		container: ".hero.slider .slider-wrapper",
		items: 1,
		navPosition: "bottom",
		controlsPosition: "bottom",
		controlsContainer: ".custom-controls",
	});

    // Auto-advance slide logic (custom durations for each slide from CMS)
    var slides = document.querySelectorAll('.hero.slider .slider-wrapper .slide:not(.tns-slide-cloned)');
    var dur;
    var autoAdvanceHandler;
    var prevSlideVideo = null;

	if (slides) {
		// Schedule the auto-advance on the first slide on page load
		dur = slides[0].dataset.duration;
		autoAdvanceHandler = setTimeout(() => {
			slider.goTo("next");
		}, dur);

        // This swaps the src with the data-src to play the video when the slide is in view
        function playVideo(slide) {
            let iframe = slide.querySelector('iframe');
            let video = slide.querySelector('video');

            if (iframe) {
                iframe.src = iframe.dataset.src;
            } else if (video) {
                video.play();
            }
        }

        // This clears the src when the slide is out of view
        function stopVideo(slide) {
            let iframe = slide.querySelector('iframe');
            let video = slide.querySelector('video');

            if (iframe) {
                setTimeout(() => {
                    iframe.src = '';
                }, 700)
            } else if (video) {
                setTimeout(() => {
                    console.log('pausing');
                    video.pause();
                    video.currentTime = 0;
                }, 700)
            }
        }

        // This clears the autoAdvanceHandler and resets it with the new duration for the active slide
        var customizedFunction = function (info, eventName) {
            var slide = slides[info.displayIndex-1];
            dur = slide.dataset.duration;
    
            clearTimeout(autoAdvanceHandler);
            autoAdvanceHandler = setTimeout(() => {
                slider.goTo('next');
            }, dur)

            // Stop video on exiting slide
            if (prevSlideVideo) {
                stopVideo(prevSlideVideo);
                prevSlideVideo = null;
            }
            // Start video on entering slide
            if (slide.classList.contains('video-embed') || slide.classList.contains('video-file')) {
                playVideo(slide);
                prevSlideVideo = slide;
            }
        }
        
        // bind function to event
        slider.events.on('transitionStart', customizedFunction);
    }
})
